const CustomRadio = Vue.extend({
    template: `
        <div class="form-group mb-0">
            <label class="btn btn-outline-product p-0 c-pointer border-0" v-bind:for="id" v-bind:class="{ active: active }">
                <input class="btn-outline-radio__input" type="radio" v-bind:name="name" v-bind:id="id" v-bind:value="value" v-bind:checked="active" v-on:change="emitChange" v-bind:aria-label="ariaLabel" />
                <div class="btn-outline-radio__title m-0" style="font-size: 0.9rem;">
                    <span class="me-2" v-show="active" v-bind:style="{ color: activeColor }" aria-hidden="true">
                        <span class="fa-stack">
                            <i class="fal fa-circle fa-stack-2x"></i>
                            <i class="fas fa-circle fa-stack-1x"></i>
                        </span>
                    </span>
                    <span class="me-2" v-show="!active" v-bind:style="{ color: inactiveColor }" aria-hidden="true">
                        <span class="fa-stack">
                            <i class="fal fa-circle fa-stack-2x"></i>
                        </span>
                    </span>
                    <slot name="label">
                        <span v-if="label" style="font-weight: 500;">{{ label }}</span>
                    </slot>
                </div>
            </label>
        </div>
    `,

    props: {
        id: {
            type: String,
            required: true
        },
        name: {
            type: String,
            required: true
        },
        label: {
            type: String
        },
        value: {
            type: String,
            required: true
        },
        active: {
            type: Boolean,
            required: true
        },
        activeColor: {
            type: String,
            default: 'rgb(48, 186, 240)'
        },
        inactiveColor: {
            type: String,
            default: 'rgb(173, 173, 173)'
        },
        ariaLabel: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            /**
             * @type {string?}
             */
            innerValue: null
        }
    },

    beforeMount() {
        this.innerValue = this.value
    },

    methods: {
        emitChange(event) {
            this.$emit('change', event.target.value)
        }
    }
})